import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {
    StyledAgendaLoaderBody,
    StyledAgendaLoaderCalendarGrid
} from '@/features/agenda/components/agenda-page-loader/style'
import {AgendaPageWrapper} from '@/features/agenda/components/agenda-page-wrapper/AgendaPageWrapper'
import {AgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/AgendaSidebarDottedDivider'
import {AgendaSidebarViewsLoader} from '@/features/agenda/components/agenda-sidebar-views/AgendaSidebarViewsLoader'
import {AgendaSidebar} from '@/features/agenda/components/agenda-sidebar/AgendaSidebar'

export const AgendaPageLoader = () => {
    return (
        <AgendaPageWrapper>
            <AgendaSidebar>
                <Flexbox direction="column" gap={3} fullWidth>
                    <Skeleton width="100%" height={266} />
                    <Skeleton width="100%" height={32} />
                    <AgendaSidebarDottedDivider />
                    <AgendaSidebarViewsLoader />
                </Flexbox>
            </AgendaSidebar>
            <StyledAgendaLoaderBody fullWidth direction="column" gap={4}>
                <Flexbox align="center" justify="space-between" fullWidth>
                    {Array.from({length: 3}).map((_, index) => (
                        <Skeleton key={index} width="280px" height="48px" />
                    ))}
                </Flexbox>
                <StyledAgendaLoaderCalendarGrid>
                    {Array.from({length: 7}).map((_, index) => (
                        <Skeleton key={index} width="100%" height="30px" />
                    ))}
                </StyledAgendaLoaderCalendarGrid>
                <StyledAgendaLoaderCalendarGrid>
                    {Array.from({length: 26}).map((_, index) => (
                        <Skeleton key={index} width="100%" height="120px" />
                    ))}
                </StyledAgendaLoaderCalendarGrid>
            </StyledAgendaLoaderBody>
        </AgendaPageWrapper>
    )
}
